// removed by extract-text-webpack-plugin
module.exports = {"spotBox":"src-display-components-ButtonGroup-index__spotBox--cQPt9","spotIcon":"src-display-components-ButtonGroup-index__spotIcon--D3CcO","activeBg":"src-display-components-ButtonGroup-index__activeBg--3SZek","menuItem":"src-display-components-ButtonGroup-index__menuItem--1SNIm"};


//////////////////
// WEBPACK FOOTER
// ./src/display/components/ButtonGroup/index.scss
// module id = 4354
// module chunks = 0